
function Column({ children }) {
    return (<div className="Column">
        {children}
    </div>)
}

export default Column